import { t } from '@lingui/macro';
import { styleConstants } from '@styles/constants';

export interface DeviceSecurityModel {
  deviceId: number;
  keys: DeviceSecurityKeysModel;
  redSecurityStatus: RedSecurityStatusType | null;
  /** Mode value exactly as recorded, unmapped. Present even when redSecurityStatus is null. */
  redSecurityModeRaw: number | null;
  health: LekHealthStatusType;
  lekExpiryUtc: string | null; // date
  lekDaysRemaining: number | null;
  lekRotationNumber: number | null;
}

export const DeviceSecurityKey = ['laek', 'dbk', 'lek'] as const;
type DeviceSecurityKeysType = (typeof DeviceSecurityKey)[number];
interface DeviceSecurityKeysModel extends Record<DeviceSecurityKeysType, boolean> {}

const RedSecurityStatus = ['Secured', 'TestMode', 'NotSecured'] as const;
export type RedSecurityStatusType = (typeof RedSecurityStatus)[number];
export const redSecurityStatusOptionsFn = (): Record<RedSecurityStatusType, { label: string; color: string }> => ({
  Secured: {
    label: t`Secured`,
    color: styleConstants.colors.green,
  },
  TestMode: {
    label: t`Test Mode`,
    color: styleConstants.colors.warningColor,
  },
  NotSecured: {
    label: t`Not Secured`,
    color: styleConstants.colors.red,
  },
});

const LekHealthStatus = ['Healthy', 'KeysMissing', 'LekExpired', 'NoKeysRecorded'] as const;
export type LekHealthStatusType = (typeof LekHealthStatus)[number];
export const healthStatusOptionsFn = (): Record<
  LekHealthStatusType,
  {
    label: string;
    color: string;
    description: string;
  }
> => ({
  Healthy: {
    label: t`Healthy`,
    color: styleConstants.colors.green,
    description: t`All keys recorded and LEK is valid`,
  },
  KeysMissing: {
    label: t`Keys Missing`,
    color: styleConstants.colors.warningColor,
    description: t`Partial key set - registration incomplete`,
  },
  LekExpired: {
    label: t`LEK Expired`,
    color: styleConstants.colors.red,
    description: t`All keys present but LEK has expired`,
  },
  NoKeysRecorded: {
    label: t`No Keys Recorded`,
    color: styleConstants.colors.grey,
    description: t`No key records found for this device`,
  },
});
